import { useNavigate } from "react-router-dom";

const DashboardOrders = ({ items = [] }) => {
    const navigate = useNavigate();
    const filteredItems = items.filter(i => i?.orderStatus === 0);
    console.log("filteredItems", filteredItems)
    return (
        <>
            <div className="d-flex justify-content-between align-items-center">
                <h5 className="mt-6 fw-semibold mb-3">Order Queue</h5>
                <button className="btn btn-primary" onClick={() => navigate("/order/new")}>View All</button>
            </div>
            <div>
                <table className="table table-striped table-bordered">
                    <thead className="thead-dark">
                        <tr>
                            <th>Sr No.</th>
                            <th>Order Name</th>
                            <th>Order Qty</th>
                            <th>Order Price</th>
                            <th>Customer</th>
                            <th>Service Type</th>
                        </tr>
                    </thead>
                    <tbody>
                        {filteredItems.length > 0 ? (
                            filteredItems.map((i, index) => (
                                <tr key={index}>
                                    <td>{index + 1}</td>
                                    <td>
                                        {i.items?.map(item => item.name).join(", ")}
                                    </td>
                                    <td>
                                        {i.items?.map(item => item.quantity).join(", ")}
                                    </td>
                                    <td>
                                        {i.items?.reduce(
                                            (total, item) => total + (item.sellPrice || 0),
                                            0
                                        )}
                                    </td>
                                    <td>{i.user?.fName || "-"}</td>

                                    <td>{i.serviceType || "-"}</td>
                                </tr>
                            ))
                        ) : (
                            <tr>
                                <td colSpan={6} className="text-center">
                                    No Orders Found
                                </td>
                            </tr>
                        )}
                    </tbody>
                </table>
            </div>
        </>

    );
};

export default DashboardOrders;
